// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"68":"4a5c3825","80":"cc4d6fef","92":"80a712f4","121":"cc4d6fef","340":"78d477de"}[chunkId] + ".chunk.css";
};